import { PermissionString } from '../constants/permissions';
import { useCurrentUser } from '../queries/currentUser';
import { checkForPermission } from '../utils';

/**
 *
 * @param permission A single permission or an array of permissions
 * @returns true if EVERY of the permissions are present
 */
export const useHasPermission = (permission: PermissionString | PermissionString[]) => {
  const query = useCurrentUser();
  const permissions = Array.isArray(permission) ? permission : [permission];

  const user: any = query.data ?? {};

  if (!query.data) {
    return false;
  }

  return permissions.every((p) => checkForPermission(user, p));
};

/**
 *
 * @param permission A single permission or an array of permissions
 * @returns true if ANY of the permissions are present
 */
export const useHasViewPermission = (permission: PermissionString | PermissionString[]) => {
  const query = useCurrentUser();
  const permissions = Array.isArray(permission) ? permission : [permission];

  const user: any = query.data ?? {};

  if (!query.data) {
    return false;
  }

  return permissions.some((p) => checkForPermission(user, p));
};
